const SCROLL_RETRY_TIMEOUT_MS = 2000;

export const getFirstUnratedIndex = (feedItemFlags = []) => {
  return feedItemFlags.findIndex((flag) => !flag?.importanceRating);
};

export const loadNextRateUpdatesPage = async ({ createResults, section }) => {
  if (!section?.thereIsMoreContent) {
    return false;
  }

  try {
    const nextPage = (section.pageNumber ?? 1) + 1;
    await createResults({ pageNumber: nextPage, setMarker: false });
    return true;
  } catch (error) {
    return false;
  }
};

export const getNextUnratedIndex = (feedItemFlags = [], fromIndex = 0) => {
  for (let i = fromIndex; i < feedItemFlags.length; i++) {
    if (!feedItemFlags[i]?.importanceRating) {
      return i;
    }
  }
  return -1;
};

export const getActiveUpdateAtIndex = ({ hits = [], feedItemFlags = [], index = 0 } = {}) => {
  const item = hits[index];
  if (!item) {
    return null;
  }
  return { ...item, importanceRating: feedItemFlags[index]?.importanceRating };
};

export const shouldUpdateActiveItem = (current, next) => {
  if (!next) {
    return current != null;
  }
  if (!current) {
    return true;
  }
  return current.objectID !== next.objectID || current.importanceRating !== next.importanceRating;
};

const scrollElementIntoView = (scrollBarRef, view, targetElement) => {
  if (!targetElement) {
    return false;
  }
  const elementRect = targetElement.getBoundingClientRect();
  const viewRect = view.getBoundingClientRect();
  const marginValue = 8;
  const relativeTop = elementRect.top - viewRect.top + view.scrollTop - marginValue;
  scrollBarRef.current.scrollTo(0, relativeTop);
  return true;
};

const scrollSelectedElementIntoView = (scrollBarRef, view) => {
  const selectedElement = view.querySelector('.rate-update-item-selected');
  return scrollElementIntoView(scrollBarRef, view, selectedElement);
};

const scrollRateUpdateItemAtIndexIntoView = (scrollBarRef, view, index) => {
  const items = view.querySelectorAll('.rate-updates-content-item');
  return scrollElementIntoView(scrollBarRef, view, items[index]);
};

const scheduleRateUpdateScroll = (scrollBarRef, tryScrollIntoView, { delay = 100, isStale } = {}) => {
  if (!scrollBarRef?.current?.view) {
    return;
  }

  const startedAt = Date.now();

  const tryScroll = () => {
    if (isStale?.() || Date.now() - startedAt > SCROLL_RETRY_TIMEOUT_MS) {
      return;
    }
    const view = scrollBarRef.current?.view;
    if (!view) {
      return;
    }
    if (!tryScrollIntoView(scrollBarRef, view)) {
      setTimeout(tryScroll, delay);
    }
  };

  setTimeout(tryScroll, delay);
};

export const scrollToRateUpdateAtIndex = (scrollBarRef, index, options = {}) => {
  scheduleRateUpdateScroll(scrollBarRef, (ref, view) => scrollRateUpdateItemAtIndexIntoView(ref, view, index), options);
};

export const scrollToSelectedRateUpdateItem = (scrollBarRef, options = {}) => {
  scheduleRateUpdateScroll(scrollBarRef, scrollSelectedElementIntoView, options);
};
